var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 0C44.7581 0 0 44.7581 0 100C0 155.242 44.7581 200 100 200C155.242 200 200 155.242 200 100C200 44.7581 155.242 0 100 0ZM149.032 126.25C150.927 128.145 150.927 131.21 149.032 133.105L133.065 149.032C131.169 150.927 128.105 150.927 126.21 149.032L100 122.581L73.75 149.032C71.8548 150.927 68.7903 150.927 66.8952 149.032L50.9677 133.065C49.0726 131.169 49.0726 128.105 50.9677 126.21L77.4194 100L50.9677 73.75C49.0726 71.8548 49.0726 68.7903 50.9677 66.8952L66.9355 50.9274C68.8306 49.0323 71.8952 49.0323 73.7903 50.9274L100 77.4194L126.25 50.9677C128.145 49.0726 131.21 49.0726 133.105 50.9677L149.073 66.9355C150.968 68.8306 150.968 71.8952 149.073 73.7903L122.581 100L149.032 126.25Z",
    fill: "#FF0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4615389a93e0d3466dfed64ab64f8b0e.svg";
export { ForwardRef as ReactComponent };